<template>
  <div class="container__announce-page">
    <div class="announce-page__guide">
      <h6>데이터 이전 중</h6>
      <h1>요청하신 데이터 이전 중입니다.</h1>
      <p>
        원활한 작업을 위해 데이터 이전 기간동안<br>
        피플박스를 이용할 수 없습니다. 작업이 완료되면<br class="mobile-new-line">소요된 기간만큼 <br class="mobile-removed-line">
        플랜을 연장해 드릴 예정입니다. <br class="mobile-new-line">(평균 3일 소요)<br>
      </p>

      <el-button
        class="default"
        @click.prevent="handleMoveToGuidePage"
      >
        1:1 상담 요청
      </el-button>
      <router-link to="/">
        <el-button 
          class="default announce-page__logout"
        >
          닫기
        </el-button>
        <router-link />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTransferAnnouncePage',
  methods: {
    async handleMoveToGuidePage() {
      window.open('https://bit.ly/3HB74vC');
    }
  }
};
</script>

<style lang="scss">
.container__announce-page {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: 0;
  background-image: url('//cdn.fiflbox.com/admin/expired-background-desktop.jpg');
  display: flex;
  align-items: center;
  justify-content: center;

  .mobile-new-line {
    display: none;
  }

  .announce-page__guide {
    width: 460px;

    h6 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.7px;
      text-align: center;
      margin: 0 auto 10px auto;
    }

    h1 {
      font-size: 24px;
      line-height: 36px;
      color: #202020;
      letter-spacing: -1.5px;
      text-align: center;
      margin-bottom: 15px;
    }

    p {
      line-height: 24px;
      font-size: 16px;
      color: #202020;
      letter-spacing: -0.8px;
      text-align: center;
      margin-bottom: 30px;
    }

    .el-button {
      margin: 0;
    }
  }

  @media screen and (max-width: 768px) {
    background-image: url('//cdn.fiflbox.com/admin/expired-background-mobile.jpg');

    .mobile-new-line {
      display: block;
    }

    .mobile-removed-line {
      display: none;
    }

    .announce-page__guide {
      width: 260px;

      h1 {
        line-height: 29px;
        font-size: 20px;
        color: #202020;
        letter-spacing: -1.25px;
        text-align: center;
      }

      p {
        font-size: 14px;
        color: #202020;
        letter-spacing: -0.75px;
        text-align: center;
      }
    }
  }

  .el-button.announce-page__logout {
    background-color: transparent;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
